import { httpRequest } from '.';
import { API_RESPONSE_SUCCESS_CODE, HttpRequestParams } from './typings';

/**
 * 基础请求，
 * 将code = 0，即请求成功，data透出，后续就不用再判断code === 0了；
 * 将code = -1 or others，即请求异常，reject掉，以后统一在catch中处理异常
 */
export default <T = undefined>(options: HttpRequestParams) => {
  return new Promise<T>((resolve, reject) => {
    const request = async () => {
      try {
        const res = await httpRequest<T>(options);
        if (res.code === API_RESPONSE_SUCCESS_CODE) {
          // 将data透出
          resolve(res.data as T);
        } else {
          // 业务异常
          reject(res);
        }
      } catch (err) {
        // 请求异常
        reject(err);
      }
    };
    request();
  });
};
